import { gql } from 'graphql-request';

export const PUNCH_SESSION_ADJUSTMENT_FIELDS = gql`
  fragment PunchSessionAdjustmentFields on PunchSessionAdjustmentDto {
    punchSessionAdjustmentId
    enterPunchClockId
    userId
    organizationId
    editedEnterTime
    editedExitTime
    originalEnterTime
    originalExitTime
    lastEditedBy
    lastEditedByUser {
      userId
      firstName
      lastName
      email
    }
    history {
      punchSessionAdjustmentHistoryId
      previousEnterTime
      newEnterTime
      previousExitTime
      newExitTime
      reason
      actorUserId
      actorUser {
        userId
        firstName
        lastName
        email
      }
      createdAt
    }
    createdAt
    updatedAt
  }
`;

export const getPunchSessionAdjustmentsByUser = gql`
  query getPunchSessionAdjustmentsByUser($userId: String!) {
    getPunchSessionAdjustmentsByUser(userId: $userId) {
      ...PunchSessionAdjustmentFields
    }
  }
  ${PUNCH_SESSION_ADJUSTMENT_FIELDS}
`;

export const editPunchSessionExit = gql`
  mutation editPunchSessionExit($input: EditPunchSessionExitInput!) {
    editPunchSessionExit(input: $input) {
      ...PunchSessionAdjustmentFields
    }
  }
  ${PUNCH_SESSION_ADJUSTMENT_FIELDS}
`;

const PunchSessionAdjustmentGraphQL = {
  queries: { getPunchSessionAdjustmentsByUser },
  mutations: { editPunchSessionExit },
};

export default PunchSessionAdjustmentGraphQL;
